import React from "react";

import {
	getListAddressOfUser,
	getAddressDetail,
	addUserAddress,
	updateUserAddress,
	removeUserAddress,
} from "../../model/profile";
import { getAllCity, getAllDistrictOfCity, getAllWardOfDistrict } from "../../model/common";

import { LoadingPage } from "../common/loading";
import { commonErr } from "../common/errors";
import { AddressType, getAddressName } from "../common/common";
import { parseAddressToLocationWithLatLng } from "../common/wdfunction";

import Session from "../common/session";
import Header from "../components/header";
import Footer from "../components/footer";
import AccountSidebar from "./components/accountsidebar";

import { FormMyAddress } from "../common/formaddress";

import { IcAddressType, IcHome, IcCompany, IcBookmark, IcPencilM, IcTrash } from "../common/svg";
import { Empty, MessageBox } from "../common/messagebox";
import empty_address from "../../static/images/empty/empty-address.svg";

const ViewMode = {
	LIST: 0,
	EDIT: 1,
	ADD: 2,
};

class UpdateAddressBox extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			err: commonErr.INIT,
			errMsg: "",
			step: 0,
			addressName: "",
			cityId: 0,
			districtId: 0,
			wardId: 0,
			street: "",
			addressType: AddressType.HOME,
			isDefault: false,
			locCity: null,
			locAddress: null,
			showMessageBox: false,
		};
	}

	componentDidMount() {
		getAllCity().then((resp) => {
			if (resp.data.error >= commonErr.SUCCESS) {
				this.setState({
					cities: resp.data.data.cities,
				});
			}
		});

		if (this.props.mode == ViewMode.EDIT && this.props.addressId && this.props.addressId > 0) {
			this.getAddressDetail(this.props.addressId);
			this.setState({
				isEdit: true,
			});
		}
	}

	getListAddress = () => {
		this.props.getListAddressOfUser();
	};

	getAddressDetail = (addressId) => {
		getAddressDetail(addressId).then((resp) => {
			if (resp.data.error >= commonErr.SUCCESS && resp.data.data.address) {
				const { address } = resp.data.data;

				this.getAllDistrictOfCity(address.cityId);
				this.getAllWardOfDistrict(address.districtId);

				this.setState({
					addressName: address.addressName,
					cityId: address.cityId,
					districtId: address.districtId,
					wardId: address.wardId,
					street: address.street,
					addressType: address.addressType,
					isDefault: address.isDefault,
					locAddress: {
						lat: address.lat,
						lng: address.lon,
					},
				});
			}
		});
	};

	getAllDistrictOfCity = (cityId) => {
		getAllDistrictOfCity(cityId).then((resp) => {
			this.setState({
				districts: resp.data.data.districts,
			});
		});
	};

	getAllWardOfDistrict = (districtId) => {
		getAllWardOfDistrict(districtId).then((resp) => {
			this.setState({
				wards: resp.data.data.wards,
			});
		});
	};

	handleInputChange = (e) => {
		this.setState({
			[e.target.name]: e.target.value,
		});
	};

	onCitySelectChange = (e) => {
		const cityId = e.target.value * 1;

		if (cityId > 0) {
			getAllDistrictOfCity(cityId).then((resp) => {
				if (resp.data.error >= commonErr.SUCCESS) {
					this.setState({
						cityId,
						districts: resp.data.data.districts,
					});
				}
			});
		} else {
			this.setState({
				cityId: 0,
				districtId: 0,
				wardId: 0,
			});
		}
	};

	onDistrictSelectChange = (e) => {
		const districtId = e.target.value * 1;
		if (districtId > 0) {
			getAllWardOfDistrict(districtId).then((resp) => {
				if (resp.data.error >= commonErr.SUCCESS) {
					this.setState({
						districtId,
						wards: resp.data.data.wards,
					});
				}
			});
		} else {
			this.setState({
				districtId: 0,
				wardId: 0,
			});
		}
	};

	onWardSelectChange = (e) => {
		const { cityId, districtId, cities, districts, wards } = this.state;
		const wardId = e.target.value * 1;
		this.setState({
			wardId,
		});

		let cityName;
		let districtName;
		let wardName;

		cities.filter((city) => {
			if (city.id === cityId) {
				cityName = city.name;
			}
		});
		districts.filter((district) => {
			if (district.id === districtId) {
				districtName = district.name;
			}
		});
		wards.filter((ward) => {
			if (ward.id === wardId) {
				wardName = ward.name;
			}
		});

		let address = `${wardName} ${districtName} ${cityName}`;
	};

	onAddressFocus = () => {
		this.setState({
			address: "",
		});
	};

	onAddressChange = (address) => {
		if (address || address !== "") {
			// parseAddressToLocation(address, (location) => {
			// 	this.setState({
			// 		locAddress: location
			// 	})
			// })
		}

		this.setState({
			street: address,
		});
	};

	onSelectFromAddress = (address) => {
		if (address.err < 0) {
			var errMsg = "";
			if (address.err === -200) {
				errMsg =
					"Bạn đã không cho phép trình duyệt truy cập vị trí hiện tại. Vui lòng cài đặt cho phép hoặc nhập địa chỉ.";
			} else {
				errMsg = "Không thể tìm thấy vị trí hiện tại của thiết bị. Vui lòng thử lại hoặc nhập địa chỉ.";
			}
			this.setState({
				err: commonErr.FAIL,
				errMsg: errMsg,
			});
		} else if (address.err === commonErr.LOADING) {
			this.setState({
				err: commonErr.LOADING,
			});
		} else {
			parseAddressToLocationWithLatLng(address.address, address.lat, address.lng, (location) => {
				let street = address.address.split(",");

				this.setState({
					err: commonErr.SUCCESS,
					street: street[0],
					locAddress: location,
				});
			});
		}
	};

	toggleDefault = () => {
		this.setState({
			isDefault: !this.state.isDefault,
		});
	};

	refreshFilled = () => {
		this.setState({
			addressName: "",
			cityId: 0,
			districtId: 0,
			wardId: 0,
			street: "",
			addressType: AddressType.HOME,
			isDefault: false,
			locCity: null,
			locAddress: null,
		});
	};

	onAddAddress = () => {
		const { addressName, locAddress, cityId, districtId, wardId, street, addressType, isDefault } = this.state;
		const data = {
			addressName,
			lat: locAddress.lat,
			lon: locAddress.lng,
			cityId,
			districtId,
			wardId,
			street,
			addressType,
			isDefault,
		};

		addUserAddress(data).then((resp) => {
			if (resp.data.error >= commonErr.SUCCESS) {
				this.onBack();
				this.setState({
					err: resp.data.error,
					errMsg: resp.data.errorMessage,
				});
			} else {
				this.setState({
					err: resp.data.error,
					errMsg: resp.data.errorMessage,
					showMessageBox: true,
				});
			}
		});
	};

	onUpdateAddress = () => {
		const { addressId } = this.props;
		const { addressName, locAddress, cityId, districtId, wardId, street, addressType, isDefault } = this.state;
		const data = {
			addressId,
			addressName,
			lat: locAddress.lat,
			lon: locAddress.lng,
			cityId,
			districtId,
			wardId,
			street,
			addressType,
			isDefault,
		};

		updateUserAddress(data).then((resp) => {
			if (resp.data.error >= commonErr.SUCCESS) {
				this.onBack();
				this.setState({
					err: resp.data.error,
					errMsg: resp.data.errorMessage,
				});
			} else {
				this.setState({
					err: resp.data.error,
					errMsg: resp.data.errorMessage,
					showMessageBox: true,
				});
			}
		});
	};

	onRemoveUserAddress = (addressId) => {
		removeUserAddress(addressId).then((resp) => {
			if (resp.data.error >= commonErr.SUCCESS) {
				this.onBack();
				this.setState({
					err: resp.data.error,
					errMsg: resp.data.errorMessage,
				});
			} else {
				this.setState({
					err: resp.data.error,
					errMsg: resp.data.errorMessage,
					showMessageBox: true,
				});
			}
		});
	};

	isValidFormAddress = () => {
		const { cityId, districtId, wardId, street, locAddress, addressName } = this.state;
		return cityId > 0 && districtId > 0 && wardId > 0 && street !== "" && locAddress !== null && addressName !== "";
	};

	hideMessageBox = () => {
		this.setState({
			showMessageBox: false,
		});
	};

	onBack = () => {
		this.getListAddress();
		this.props.onBack();
	};

	render() {
		const { show, addressId, mode } = this.props;
		const {
			err,
			errMsg,
			step,
			cities,
			districts,
			wards,
			street,
			locCity,
			cityId,
			districtId,
			wardId,
			locAddress,
			isDefault,
			addressType,
			addressName,
			isEdit,
		} = this.state;

		let content;

		// if (step === 1) {
		// 	if (err === commonErr.SUCCESS) {
		// 		content = <div className="form-default form-s">
		// 				<div className="line-form">
		// 					<div className="textAlign-center"><i className="ic ic-verify"></i> Cập nhật địa chỉ thành công</div>
		// 				</div>
		// 				<div className="clear"></div>
		// 				<div className="space m"></div>
		// 				<button className="btn btn-primary btn--m" type="button" onClick={this.close}>Hoàn tất</button>
		// 		</div>
		// 	}

		// } else {

		// }

		return (
			<div className="content-item address-list">
				<div className="title">
					<h4>{mode === ViewMode.ADD ? "Thêm địa chỉ mới" : "Chỉnh sửa địa chỉ"}</h4>
					{mode === ViewMode.EDIT && (
						<div className="wrap-svg remove-address" onClick={() => this.onRemoveUserAddress(addressId)}>
							<IcTrash />
						</div>
					)}
				</div>
				<div className="content">
					<div className="address-type">
						<div className="type-title">
							<p>Loại địa điểm </p>
							<div className="custom-switch">
								<input type="checkbox" id="cb_default" checked={isDefault} onChange={this.toggleDefault} />
								<label htmlFor="cb_default" />
								<label htmlFor="cb_default">Đặt làm địa chỉ mặc định</label>
							</div>
						</div>
						<div className="type-pick">
							<div className="custom-radio">
								<input
									type="radio"
									id="cbHome"
									name="addressType"
									value={AddressType.HOME}
									onChange={(e) => this.handleInputChange(e)}
									checked={addressType === AddressType.HOME}
								/>
								<label htmlFor="cbHome">
									<div className="wrap-svg">
										<IcHome />
									</div>
									Nhà riêng
								</label>
							</div>
							<div className="custom-radio">
								<input
									type="radio"
									id="cbCity"
									name="addressType"
									value={AddressType.COMPANY}
									onChange={(e) => this.handleInputChange(e)}
									checked={addressType === AddressType.COMPANY}
								/>
								<label htmlFor="cbCity">
									<div className="wrap-svg">
										<IcCompany />
									</div>
									Công ty
								</label>
							</div>
							<div className="custom-radio">
								<input
									type="radio"
									id="cbOthers"
									name="addressType"
									value={AddressType.OTHERS}
									onChange={(e) => this.handleInputChange(e)}
									checked={addressType === AddressType.OTHERS}
								/>
								<label htmlFor="cbOthers">
									<div className="wrap-svg">
										<IcBookmark />
									</div>
									Khác
								</label>
							</div>
						</div>
					</div>
					<div className="address-type">
						<div className="type-title">
							<p>Tên gợi nhớ</p>
						</div>
						<div className="custom-input">
							<div className="wrap-input">
								<input
									type="text"
									name="addressName"
									value={addressName}
									onChange={(e) => this.handleInputChange(e)}
									placeholder="Nhập tên cho địa chỉ của bạn"
								/>
							</div>
						</div>
					</div>

					<FormMyAddress
						cities={cities}
						districts={districts}
						wards={wards}
						cityId={cityId}
						districtId={districtId}
						wardId={wardId}
						address={street}
						locCity={locCity}
						locAddress={locAddress}
						onCitySelectChange={this.onCitySelectChange}
						onDistrictSelectChange={this.onDistrictSelectChange}
						onWardSelectChange={this.onWardSelectChange}
						onAddressChange={this.onAddressChange}
						onAddressFocus={this.onAddressFocus}
						onSelectFromAddress={this.onSelectFromAddress}
					/>

					<div className="apply-button">
						<a className="btn btn-cancel" onClick={this.props.onBack}>
							Hủy
						</a>
						{isEdit ? (
							<a
								className="btn btn-primary btn--m"
								disabled={!this.isValidFormAddress()}
								onClick={() => this.onUpdateAddress()}>
								Cập nhật
							</a>
						) : (
							<a className="btn btn-primary btn--m" disabled={!this.isValidFormAddress()} onClick={this.onAddAddress}>
								Xác nhận
							</a>
						)}
					</div>
				</div>
				<MessageBox
					error={commonErr.FAIL}
					show={this.state.showMessageBox}
					hideModal={this.hideMessageBox}
					title={errMsg}
				/>
			</div>
		);
	}
}

const AddressItem = ({ address, showUpdateAddress }) => {
	const onUpdate = (id) => {
		showUpdateAddress(id);
	};

	return (
		<div className={`address-item ${address.isDefault ? "default" : ""}`}>
			<div className="address-content">
				<div className="wrap-svg">{IcAddressType(address.addressType)}</div>
				<div className="wrap-text">
					<p className="address-title">{address.addressName}</p>
					<p>{getAddressName(address)}</p>
				</div>
			</div>
			<div className="wrap-svg address-edit" onClick={() => onUpdate(address.addressId)}>
				<IcPencilM />
			</div>
		</div>
	);
};

const ListAddress = ({ showAddAddress, addresses, showUpdateAddress }) => {
	return (
		<div className="content-item address-list">
			<div className="title">
				<h4>Địa chỉ đã lưu</h4>
				<a className="btn btn--s" onClick={showAddAddress}>
					Thêm địa chỉ mới
				</a>
			</div>
			<div className="content">
				{addresses &&
					addresses.map((address) => (
						<AddressItem key={address.addressId} address={address} showUpdateAddress={showUpdateAddress} />
					))}
			</div>
		</div>
	);
};

const EmptyAddress = ({ showAddAddress }) => {
	return (
		<div className="content-item address-list">
			<div className="title">
				<h4>Địa chỉ đã lưu</h4>
				<a className="btn btn--s" onClick={showAddAddress}>
					Thêm địa chỉ mới
				</a>
			</div>
			<div className="content">
				<Empty msg={"Bạn chưa có địa chỉ"} img={empty_address} />
			</div>
		</div>
	);
};

class MyAddress extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			err: commonErr.INNIT,
			errMsg: "",
			isOpenAddAddress: false,
			isOpenUpdateAddress: false,
			mode: ViewMode.LIST,
		};
	}

	componentDidMount() {
		window.scrollTo(0, 0);
		this.setState({
			err: commonErr.LOADING,
		});
		this.getListAddressOfUser();
	}

	getListAddressOfUser = () => {
		getListAddressOfUser(0, 10).then((resp) => {
			if (resp.data.error >= commonErr.SUCCESS && resp.data.data) {
				this.setState({
					addresses: resp.data.data.addresses,
					more: resp.data.data.more,
					err: resp.data.error,
				});
			} else {
				this.setState({
					err: resp.data.error,
					errMsg: resp.data.errorMessage,
				});
			}
		});
	};

	showAddAddress = () => {
		window.scrollTo(0, 0);
		this.setState({
			addressId: null,
			mode: ViewMode.ADD,
		});
	};

	showUpdateAddress = (addressId) => {
		window.scrollTo(0, 0);
		this.setState({
			addressId: addressId,
			mode: ViewMode.EDIT,
		});
	};

	onBack = () => {
		window.scrollTo(0, 0);
		this.setState({
			mode: ViewMode.LIST,
		});
	};

	render() {
		let content;
		const { err, errMsg, addresses, addressId, isOpenAddAddress, isOpenUpdateAddress, mode } = this.state;

		if (mode === ViewMode.LIST) {
			if (err === commonErr.INNIT || err === commonErr.LOADING) {
				content = <LoadingPage />;
			} else if (err >= commonErr.SUCCESS && addresses && addresses.length > 0) {
				content = (
					<ListAddress
						addresses={addresses}
						showUpdateAddress={this.showUpdateAddress}
						showAddAddress={this.showAddAddress}
					/>
				);
			} else if (err >= commonErr.SUCCESS && (!addresses || addresses.length === 0)) {
				content = <EmptyAddress showAddAddress={this.showAddAddress} />;
			}
		} else if (mode === ViewMode.ADD) {
			content = (
				<UpdateAddressBox mode={ViewMode.ADD} onBack={this.onBack} getListAddressOfUser={this.getListAddressOfUser} />
			);
		} else {
			content = (
				<UpdateAddressBox
					addressId={addressId}
					mode={ViewMode.EDIT}
					onBack={this.onBack}
					getListAddressOfUser={this.getListAddressOfUser}
				/>
			);
		}

		return (
			<div className="mioto-layout">
				<Session />
				<Header />
				<section className="body">
					<div className="account-section sec space">
						<div className="m-container">
							<div className="account-container">
								<AccountSidebar />
								<div className="content-account">
									<div className="content-title">
										<h4>Địa chỉ của tôi</h4>
									</div>
									{content}
								</div>
							</div>
						</div>
					</div>
				</section>
				<Footer />
			</div>
		);
	}
}

export default MyAddress;

{
	/* <div className="content-item address-list">
<div className="title">
  <h4>Địa chỉ đã lưu</h4><a className="btn btn--s">Thêm địa chỉ mới</a>
</div>
<div className="content"> 
  <div className="address-item default">
	<div className="address-content"> 
	  <div className="wrap-svg">
		<svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		  <path d="M14.7797 21.2503H9.21973V15.3003C9.21973 14.7503 9.66973 14.3003 10.2197 14.3003H13.7797C14.3297 14.3003 14.7797 14.7503 14.7797 15.3003V21.2503V21.2503Z" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
		  <path d="M21.25 11.3901V18.1001C21.25 19.8401 19.91 21.2501 18.25 21.2501H5.75C4.09 21.2501 2.75 19.8401 2.75 18.1001V11.3901C2.75 10.4501 3.14 9.57012 3.83 8.97012L10.08 3.48012C11.19 2.50012 12.81 2.50012 13.92 3.48012L20.17 8.97012C20.86 9.57012 21.25 10.4501 21.25 11.3901Z" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
		</svg>
	  </div>
	  <div className="wrap-text"> 
		<p className="address-title">Nhà riêng</p>
		<p>93B Võ Văn Tần, phường Võ Thị Sáu, Quận 3, TPHCM</p>
	  </div>
	</div>
	<div className="wrap-svg address-edit">
	  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M6.46001 21.24L21.25 6.45L17.55 2.75L2.75999 17.54L2.75 21.25L6.46001 21.24Z" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
		<path d="M15.3496 6.12988L17.8696 8.64987" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
	  </svg>
	</div>
  </div>
  <div className="line-page" />
  <div className="address-item"> 
	<div className="address-content"> 
	  <div className="wrap-svg">
		<svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		  <path d="M2.75 21.25H21.25" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
		  <path d="M16.1096 5.83008H7.88957C6.18957 5.83008 4.80957 7.21008 4.80957 8.91008V21.2401H19.1996V8.92008C19.1896 7.21008 17.8096 5.83008 16.1096 5.83008Z" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
		  <path d="M12.0004 17.1401C10.8604 17.1401 9.94043 18.0601 9.94043 19.2001V21.0401C9.94043 21.1601 10.0404 21.2601 10.1604 21.2601H13.8404C13.9604 21.2601 14.0604 21.1601 14.0604 21.0401V19.2001C14.0604 18.0601 13.1404 17.1401 12.0004 17.1401Z" stroke="#242420" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
		  <path d="M15.0896 8.91992H14.0596V9.94992H15.0896V8.91992Z" stroke="#242420" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
		  <path d="M9.94992 8.91992H8.91992V9.94992H9.94992V8.91992Z" stroke="#242420" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
		  <path d="M15.0896 13.54H14.0596V14.57H15.0896V13.54Z" stroke="#242420" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
		  <path d="M9.94992 13.54H8.91992V14.57H9.94992V13.54Z" stroke="#242420" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
		  <path d="M15.0796 2.75H8.90961C7.76961 2.75 6.84961 3.67 6.84961 4.81V5.84H17.1296V4.81C17.1396 3.67 16.2196 2.75 15.0796 2.75Z" stroke="#242420" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
		</svg>
	  </div>
	  <div className="wrap-text"> 
		<p className="address-title">Công ty</p>
		<p>93B Võ Văn Tần, phường Võ Thị Sáu, Quận 3, TPHCM</p>
	  </div>
	</div>
	<div className="wrap-svg address-edit">
	  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M6.46001 21.24L21.25 6.45L17.55 2.75L2.75999 17.54L2.75 21.25L6.46001 21.24Z" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
		<path d="M15.3496 6.12988L17.8696 8.64987" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
	  </svg>
	</div>
  </div>
  <div className="address-item"> 
	<div className="address-content"> 
	  <div className="wrap-svg">
		<svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		  <path d="M16.5802 20.9902C15.2602 19.8102 13.9502 18.5702 12.6302 17.4302C12.2602 17.1102 11.7102 17.1102 11.3402 17.4302C10.0302 18.5602 8.72023 19.8002 7.41023 20.9802C6.77023 21.5602 5.74023 21.1002 5.74023 20.2302V4.74023C5.74023 3.64023 6.64023 2.74023 7.74023 2.74023H16.2402C17.3402 2.74023 18.2402 3.64023 18.2402 4.74023V20.2302C18.2502 21.1102 17.2302 21.5702 16.5802 20.9902Z" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
		</svg>
	  </div>
	  <div className="wrap-text"> 
		<p className="address-title">Nhà riêng</p>
		<p>93B Võ Văn Tần, phường Võ Thị Sáu, Quận 3, TPHCM</p>
	  </div>
	</div>
	<div className="wrap-svg address-edit">
	  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M6.46001 21.24L21.25 6.45L17.55 2.75L2.75999 17.54L2.75 21.25L6.46001 21.24Z" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
		<path d="M15.3496 6.12988L17.8696 8.64987" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
	  </svg>
	</div>
  </div>
</div>
</div> */
}

{
	/* <div className="content-item address-list">
<div className="title">
  <h4>Thêm địa chỉ mới</h4>
</div>
<div className="content"> 
  <div className="address-type"> 
	<div className="type-title"> 
	  <p>Loại địa điểm </p>
	  <div className="custom-switch">
		<input type="checkbox" id="sw1" name="swqqw" />
		<label htmlFor="sw1" />
		<label htmlFor="sw1">Đặt làm địa chỉ mặc định</label>
	  </div>
	</div>
	<div className="type-pick"> 
	  <div className="custom-radio"> 
		<input type="radio" id="add1" name="add" defaultChecked />
		<label htmlFor="add1">
		  <div className="wrap-svg"><svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			  <path d="M14.7797 21.2503H9.21973V15.3003C9.21973 14.7503 9.66973 14.3003 10.2197 14.3003H13.7797C14.3297 14.3003 14.7797 14.7503 14.7797 15.3003V21.2503V21.2503Z" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
			  <path d="M21.25 11.3901V18.1001C21.25 19.8401 19.91 21.2501 18.25 21.2501H5.75C4.09 21.2501 2.75 19.8401 2.75 18.1001V11.3901C2.75 10.4501 3.14 9.57012 3.83 8.97012L10.08 3.48012C11.19 2.50012 12.81 2.50012 13.92 3.48012L20.17 8.97012C20.86 9.57012 21.25 10.4501 21.25 11.3901Z" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
			</svg>
		  </div>Nhà riêng
		</label>
	  </div>
	  <div className="custom-radio"> 
		<input type="radio" id="add2" name="add" />
		<label htmlFor="add2">
		  <div className="wrap-svg"><svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			  <path d="M2.75 21.25H21.25" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
			  <path d="M16.1096 5.83008H7.88957C6.18957 5.83008 4.80957 7.21008 4.80957 8.91008V21.2401H19.1996V8.92008C19.1896 7.21008 17.8096 5.83008 16.1096 5.83008Z" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
			  <path d="M12.0004 17.1401C10.8604 17.1401 9.94043 18.0601 9.94043 19.2001V21.0401C9.94043 21.1601 10.0404 21.2601 10.1604 21.2601H13.8404C13.9604 21.2601 14.0604 21.1601 14.0604 21.0401V19.2001C14.0604 18.0601 13.1404 17.1401 12.0004 17.1401Z" stroke="#242420" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
			  <path d="M15.0896 8.91992H14.0596V9.94992H15.0896V8.91992Z" stroke="#242420" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
			  <path d="M9.94992 8.91992H8.91992V9.94992H9.94992V8.91992Z" stroke="#242420" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
			  <path d="M15.0896 13.54H14.0596V14.57H15.0896V13.54Z" stroke="#242420" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
			  <path d="M9.94992 13.54H8.91992V14.57H9.94992V13.54Z" stroke="#242420" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
			  <path d="M15.0796 2.75H8.90961C7.76961 2.75 6.84961 3.67 6.84961 4.81V5.84H17.1296V4.81C17.1396 3.67 16.2196 2.75 15.0796 2.75Z" stroke="#242420" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
			</svg>
		  </div>Công ty
		</label>
	  </div>
	  <div className="custom-radio"> 
		<input type="radio" id="add3" name="add" />
		<label htmlFor="add3">
		  <div className="wrap-svg"><svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			  <path d="M16.5802 20.9902C15.2602 19.8102 13.9502 18.5702 12.6302 17.4302C12.2602 17.1102 11.7102 17.1102 11.3402 17.4302C10.0302 18.5602 8.72023 19.8002 7.41023 20.9802C6.77023 21.5602 5.74023 21.1002 5.74023 20.2302V4.74023C5.74023 3.64023 6.64023 2.74023 7.74023 2.74023H16.2402C17.3402 2.74023 18.2402 3.64023 18.2402 4.74023V20.2302C18.2502 21.1102 17.2302 21.5702 16.5802 20.9902Z" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
			</svg>
		  </div>Khác
		</label>
	  </div>
	</div>
  </div>
  <div className="address-type"> 
	<div className="type-title"> 
	  <p>Tên gợi nhớ</p>
	</div>
	<div className="custom-input"> 
	  <div className="wrap-input">
		<input type="text" defaultValue placeholder="Nhập tên cho địa chỉ của bạn" />
	  </div>
	</div>
  </div>
  <div className="three-item">
	<div className="address-type"> 
	  <div className="type-title"> 
		<p>Thành phố</p>
	  </div>
	  <div className="custom-select"> 
		<select> 
		  <option value={0}>Hồ Chí Minh</option>
		  <option value={1}>Hồ Chí Minh</option>
		  <option value={2}>Hồ Chí Minh</option>
		  <option value={3}>Hồ Chí Minh</option>
		</select>
	  </div>
	</div>
	<div className="address-type"> 
	  <div className="type-title"> 
		<p>Quận&nbsp;/&nbsp;Huyện</p>
	  </div>
	  <div className="custom-select"> 
		<select> 
		  <option value={0}>Quận 1 </option>
		  <option value={1}>Quận 1 </option>
		  <option value={2}>Quận 1 </option>
		  <option value={3}>Quận 1 </option>
		</select>
	  </div>
	</div>
	<div className="address-type"> 
	  <div className="type-title"> 
		<p>Phường&nbsp;/&nbsp;Xã</p>
	  </div>
	  <div className="custom-select"> 
		<select> 
		  <option value={0}>Phường ĐAKAO </option>
		  <option value={1}>Phường ĐAKAO </option>
		  <option value={2}>Phường ĐAKAO </option>
		  <option value={3}>Phường ĐAKAO </option>
		</select>
	  </div>
	</div>
  </div>
  <div className="address-type"> 
	<div className="type-title"> 
	  <p>Địa chỉ</p>
	</div>
	<div className="custom-input"> 
	  <div className="wrap-input here-autocomplete">
		<input type="text" defaultValue placeholder="Nhập địa chỉ của bạn" />
		<div className="autocomplt-box"> 
		  <div className="location-item"> 
			<div className="wrap-svg">
			  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path d="M10.0003 2.29102C6.92532 2.29102 4.41699 4.79935 4.41699 7.87435C4.41699 11.691 9.41699 17.3077 9.62533 17.541C9.82533 17.766 10.1753 17.766 10.3753 17.541C10.592 17.3077 15.5837 11.691 15.5837 7.87435C15.5837 4.79935 13.0753 2.29102 10.0003 2.29102Z" stroke="#767676" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
				<path d="M10.3205 9.82102C11.3977 9.64956 12.132 8.63727 11.9605 7.56004C11.789 6.4828 10.7768 5.74853 9.69953 5.92C8.62229 6.09147 7.88802 7.10374 8.05949 8.18097C8.23096 9.25821 9.24323 9.99249 10.3205 9.82102Z" stroke="#767676" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
			  </svg>
			</div>
			<p>Đường Vo Van Tan, phường Vo Thi Sau, quận 3, thành phố Hồ Chí Minh</p>
		  </div>
		  <div className="location-item"> 
			<div className="wrap-svg">
			  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path d="M10.0003 2.29102C6.92532 2.29102 4.41699 4.79935 4.41699 7.87435C4.41699 11.691 9.41699 17.3077 9.62533 17.541C9.82533 17.766 10.1753 17.766 10.3753 17.541C10.592 17.3077 15.5837 11.691 15.5837 7.87435C15.5837 4.79935 13.0753 2.29102 10.0003 2.29102Z" stroke="#767676" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
				<path d="M10.3205 9.82102C11.3977 9.64956 12.132 8.63727 11.9605 7.56004C11.789 6.4828 10.7768 5.74853 9.69953 5.92C8.62229 6.09147 7.88802 7.10374 8.05949 8.18097C8.23096 9.25821 9.24323 9.99249 10.3205 9.82102Z" stroke="#767676" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
			  </svg>
			</div>
			<p>Đường Vo Van Tan, phường Vo Thi Sau, quận 3, thành phố Hồ Chí Minh</p>
		  </div>
		  <div className="location-item"> 
			<div className="wrap-svg">
			  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path d="M10.0003 2.29102C6.92532 2.29102 4.41699 4.79935 4.41699 7.87435C4.41699 11.691 9.41699 17.3077 9.62533 17.541C9.82533 17.766 10.1753 17.766 10.3753 17.541C10.592 17.3077 15.5837 11.691 15.5837 7.87435C15.5837 4.79935 13.0753 2.29102 10.0003 2.29102Z" stroke="#767676" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
				<path d="M10.3205 9.82102C11.3977 9.64956 12.132 8.63727 11.9605 7.56004C11.789 6.4828 10.7768 5.74853 9.69953 5.92C8.62229 6.09147 7.88802 7.10374 8.05949 8.18097C8.23096 9.25821 9.24323 9.99249 10.3205 9.82102Z" stroke="#767676" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
			  </svg>
			</div>
			<p>Đường Vo Van Tan, phường Vo Thi Sau, quận 3, thành phố Hồ Chí Minh</p>
		  </div>
		</div>
	  </div>
	</div>
  </div>
  <div className="apply-button"> <a className="btn btn-cancel">Hủy</a><a className="btn btn-primary btn--m">Xác nhận</a></div>
</div>
</div> */
}
